/**
 * Chave estável para comparar se um objeto de filtro mudou.
 *
 * Substitui o `object-hash`, que era importado por `store/modules/comissoes.js` sem
 * nunca ter sido declarado no package.json — vinha pendurado na árvore do Vue CLI, na
 * versão 1.3.1. Quando a dependência foi tornada explícita, ficou visível o que ela
 * traz junto: o `object-hash` usa o módulo `crypto` do Node. O webpack 4 entregava um
 * polyfill de browser e ninguém reparou; sob um empacotador que não polifila builtin
 * do Node, o app morre no boot com "Cannot read properties of undefined (reading
 * 'crypto')". Foi assim que apareceu, no ensaio da janela.
 *
 * O uso real não pede hash nenhum. O valor é comparado com o anterior, em memória, na
 * mesma sessão (`comissoes.js:124`): nunca é gravado, nunca trafega, nunca precisa ser
 * curto nem opaco. Uma serialização estável resolve, sem dependência.
 *
 * O que "estável" quer dizer aqui: as chaves são ordenadas antes de serializar, porque
 * `JSON.stringify` respeita a ordem de inserção e o filtro é remontado com spread em
 * vários pontos (`{ ...state.filtrosComissoes, ... }`). Sem a ordenação, o mesmo
 * filtro lógico geraria strings diferentes e a tela recarregaria à toa.
 */
export function chaveEstavel(valor) {
  return JSON.stringify(valor, (_chave, v) => {
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      return Object.keys(v)
        .sort()
        .reduce((acc, k) => {
          acc[k] = v[k];
          return acc;
        }, {});
    }
    return v;
  });
}

export default chaveEstavel;
